<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div>
    <ListStyleForm v-if="step === 1" @next-step="nextStep" :initdata="initData" @prev-step="onClickPrev" />
    <ListStyleResult v-else @next-step="nextStep" :initdata="resultData" @prev-step="onClickPrev" />
  </div>
</template>

<script>
import ListStyleForm from './components/ListStyleForm';
import ListStyleResult from './components/ListStyleResult';
import ClinicApi from '@/api/clinicApi.js';
// import {getQueryString} from '../utils/utils'
export default {
  name: 'ClinicIndex',
  components: {
    ListStyleForm, ListStyleResult
  },
  props: {
    initdata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      step: 1,
      resultData: {},
      icon: "",
      initData: {}
    }
  },
  created() {

  },
  mounted() {
    this.id = this.$route.query.id
    document.title = '智能营养师';
    // this.getResult();
  },
  watch: {
    // 监听路由变化
    '$route.query.clearCache': {
      handler(newVal) {
        console.log('clearCache', newVal)
        if (newVal) {
          this.clearAndReload();
        }
      },
      immediate: true
    }
  },
  methods: {
    async clearAndReload() {
      this.loading = true;
      try {
        // 清除本地缓存
        this.step=1
        this.resultData = {}
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false;
      }
    },
    onClickPrev({type}) {
      if(type==='listStyleResult'){
        this.step--
      }
      if(type==='listStyleForm'){
        this.$outer.push({path:"/clinic/index",query:{doctorId:this.doctorId,clearCache:false}})
      }
    },
    nextStep({ type, data }) {
      console.log('nextStep', this.cachedViews)
      if (type === 'listStyleResult') {
        this.$router.push({
          path: '/clinic/index',
          query: {
            doctorId: this.doctorId || this.$route.query.doctorId,
            clearCache: true
          }
        })
      }
      if (type === 'listStyleForm') {
        this.handleOk(data)
        this.initData = { ...data }
      }
    },
    handleOk(val) {
      ClinicApi.addPatientLifeStyleAssessmentRecord({
        id: this.id,
        ...val
      }).then(({ data }) => {
        if (data?.success) {
          this.getResult();
        }else{
          this.$toast(data.message || '保存失败');
        }
      })
    },
    getResult() {
      ClinicApi.searchLifeStyleRecordById({
        id: this.id
      }).then(({ data }) => {
        if (data?.success) {
          // this.step++;
          this.resultData = {
            ...data.data,
          };
          this.step=2;

        }else{
          this.$toast(data.message || '查询失败');
        }
      })
    }
  },
};
</script>

<style scoped></style>
